import React from 'react'
import GitHubIcon from '@mui/icons-material/GitHub';
import VisibilityIcon from '@mui/icons-material/Visibility';
import styled from 'styled-components';


const ProjectStyled = styled.div`
    margin-top: 7rem;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 6rem;
    @media screen and (max-width:1100px){
        grid-template-columns: repeat(1, 1fr);
    }
    @media screen and (max-width:600px){
        grid-template-columns: 100%;
    }
    .card{
        position: relative;
        height: 220px;
        box-shadow: rgba(0, 0, 0, 0.45) 0px 25px 20px -20px;
        transition: 0.5s;
        border-radius: 10px;
        padding: 20px 30px;
        background: var(--background-dark-grey);
        cursor: pointer;
        &:hover {
            height: 570px;
        }
        &:hover>.content {
            opacity: 1;
            transform: translateY(-50px)
        }

        .imgBox {
            position: relative;
            border-radius: 10px;
            width: 100%;
            transform: translateY(-80px);
            z-index: 1000;
            img{
                width: 100%;
                height: 220px;
                border-radius: 10px;
                object-fit: cover;
            }
        }
        @media screen and (max-width:600px){
            height: 170px;
            &:hover{
                height: inherit;
            }
            .imgBox img{
                height: 170px;
            }
        }

        .content {
            padding: 10px 20px;
            text-align: center;
            transform: translateY(-300px);
            opacity: 0;
            transition: 0.3s;
            p{
                text-align: justify;
            }
            h6{
                margin-top: -1.2rem;
                font-size: 1.5rem;
            }
        }

        .btnDiv {
            margin-top:1rem;
            position: relative;
            display: flex;
            gap: 1rem;
            justify-content: space-around;
            align-items: center;
            button {
                background-color: var(--primary-color);
                display: flex;
                gap: 8px;
                justify-content:center;
                align-items: center;
                border: none;
                width: 180px;
                font-size:15px;
                cursor: pointer;
                padding: .8rem;
                color: white;
                text-transform: uppercase;
                position: relative;
                transition: all .4s ease-in-out;
                &::after{
                    content: "";
                    position: absolute;
                    width: 0;
                    height: .2rem;
                    transition: all .4s ease-in-out;
                    left: 0;
                    bottom: 0;
                    opacity: .7;
                }
                &:hover::after{
                    width: 100%;
                    background-color: var(--white-color);
                }
            }
            @media screen and (max-width:600px){
                flex-direction: column;
            }
        }
        .tech{
            margin:20px 0;
            display: flex;
            flex-wrap: wrap;
            justify-content:center;
            align-items: center;
            gap: 12px;
            .icon{
                display: flex;
                flex-direction: column;
            }
            .icon>p{
                font-size:13px;
            }
            @media screen and (max-width:600px){
                flex-wrap: wrap;
            }
        }
    }
`

const Project = ({ menuItem }) => {

    return (

        <ProjectStyled>
            {menuItem.map(el => (
                <div key={el.id} className="card">
                    <div className="imgBox">
                        <img src={el.image} alt="projectImage" />
                    </div>

                    <div className="content">
                        <h6>{el.title}</h6>
                        <p>{el.description}</p>
                        <div className="btnDiv">
                            <a href={el.source} target="_blank" rel="noopener noreferrer">
                                {el.source !== "" ? <button>Source Code<GitHubIcon /></button>
                                    : <button disabled={true}>Not Available<GitHubIcon /></button>}
                            </a>
                            <a href={el.view} target="_blank" rel="noopener noreferrer">
                                {el.view ? <button>Go Live<VisibilityIcon /></button>
                                    : <button>Coming Soon<VisibilityIcon /></button>}
                            </a>
                        </div>
                        <div className="tech">
                            {el.tech.map((item, i) => (
                                <div key={i} className="icon">
                                    <div>{item[0]}</div>
                                    <p>{item[1]}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            ))}
        </ProjectStyled>
    )
}

export default Project